import anime from '../libs/anime'
import hammer from '../libs/hammer'

class Module08Chiffres {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.sliderChiffres = document.querySelectorAll('.module-08-chiffres .chiffres_slider');
    }

    let registerEvents = () => {
      for (let i = 0; i < cache.sliderChiffres.length; i++) {
        const sliderChiffre = cache.sliderChiffres[i];
        const slides = sliderChiffre.querySelectorAll('.chiffre_slide');
        if(slides.length > 1) {
            let timer = setInterval(() => {
            let index = sliderChiffre.dataset.index;
            if(index < slides.length - 1) {
                index++;
                } else {
                index = 0;
            }
            slide(sliderChiffre, index)
            }, 3000);

            const bullets = sliderChiffre.closest('.module-08-chiffres').querySelectorAll('.bullet');
            bullets.forEach((bullet) => {
                bullet.addEventListener('click', () => {
                clearInterval(timer);
                let index = bullet.dataset.slide;
                slide(sliderChiffre, index);
                timer = setInterval(() => {
                    let index = sliderChiffre.dataset.index;
                    if(index < slides.length - 1) {
                        index++;
                        } else {
                        index = 0;
                    }
                    slide(sliderChiffre, index)
                }, 3000);
                });
            })

          const hammerSlider = new Hammer(sliderChiffre);
          hammerSlider.on('swipe', (event) => {
            let index = sliderChiffre.dataset.index;
            if(event.direction === Hammer.DIRECTION_RIGHT) {
                clearInterval(timer);
              if(index < slides.length - 1) {
                  index++;
                } else {
                  index = 0;
              }
              slide(sliderChiffre, index)
              timer = setInterval(() => {
                let index = sliderChiffre.dataset.index;
                if(index < slides.length - 1) {
                    index++;
                    } else {
                    index = 0;
                }
                slide(sliderChiffre, index)
            }, 3000);
            } else if(event.direction === Hammer.DIRECTION_LEFT) {
                clearInterval(timer);
              if(index > 0) {
                  index--;
                } else {
                  index = slides.length - 1;
              }
              slide(sliderChiffre, index)
              timer = setInterval(() => {
                let index = sliderChiffre.dataset.index;
                if(index < slides.length - 1) {
                    index++;
                    } else {
                    index = 0;
                }
                slide(sliderChiffre, index)
            }, 3000);
            }
          });

        }
      }
    }

    let slide = (slider, targetIndex) => {
      let index = slider.dataset.index;
      const slides = slider.querySelectorAll('.chiffre_slide');
      const bullets = slider.closest('.module-08-chiffres').querySelectorAll('.bullet');
      const activeSlide = slides[index];
      const activeBullet = bullets[index];

      activeBullet.classList.remove('active');
      slider.dataset.index = targetIndex;

      const targetSlide = slides[targetIndex];
      const targetBullet = bullets[targetIndex];

      targetBullet.classList.add('active');
      targetSlide.classList.add('active');

      anime({
        targets: activeSlide,
        opacity: 0,
        scale: [1, 1.2],
        duration: 500,
        easing: 'easeInOutQuad',
      });
      anime({
        targets: targetSlide,
        opacity: 1,
        scale: [0.9, 1],
        duration: 500,
        easing: 'easeInOutQuad',
      });
    }
    
    initFunc();
  }
}
export { Module08Chiffres }